export const SET_CURRENT_USER = "SET_CURRENT_USER";
export const IS_LOADING = "IS_LOADING";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_ERROR = "LOGIN_ERROR";
export const LOGOUT_SUCCESS = "LOGOUT_SUCCESS";
export const USERLIST_SUCCESS = "USERLIST_SUCCESS";

export const PAGE_LIST_SUCCESS = "PAGE_LIST_SUCCESS";

export const USER_DETAIL_SUCCESS = "USER_DETAIL_SUCCESS";
export const USER_VERIFICATION_SUCCESS = "USER_VERIFICATION_SUCCESS";

//LOGISTIC TYPES

//capabilites section
export const LOGISTICS_CAPABILITIES_LIST_SUCCESS =
  "LOGISTICS_CAPABILITIES_LIST_SUCCESS";
export const LOGISTICS_CAPABILITIES_LIST_ERROR =
  "LOGISTICS_CAPABILITIES_LIST_ERROR";

export const LOGISTICS_CAPABILITIES_UPDATE_SUCCESS =
  "LOGISTICS_CAPABILITIES_UPDATE_SUCCESS";
export const LOGISTICS_CAPABILITIES_UPDATE_ERROR =
  "LOGISTICS_CAPABILITIES_UPDATE_ERROR";

//experince section

export const LOGISTICS_EXPERIENCE_ADD_SUCCESS =
  "LOGISTICS_EXPERIENCE_ADD_SUCCESS";
export const LOGISTICS_EXPERIENCE_ADD_ERROR = "LOGISTICS_EXPERIENCE_ADD_ERROR";

export const LOGISTICS_EXPERIENCE_DELETE_SUCCESS =
  "LOGISTICS_EXPERIENCE_DELETE_SUCCESS";
export const LOGISTICS_EXPERIENCE_DELETE_ERROR =
  "LOGISTICS_EXPERIENCE_DELETE_ERROR";

export const LOGISTICS_EXPERIENCE_LIST_SUCCESS =
  "LOGISTICS_EXPERIENCE_LIST_SUCCESS";
export const LOGISTICS_EXPERIENCE_LIST_ERROR =
  "LOGISTICS_EXPERIENCE_LIST_ERROR";

export const LOGISTICS_EXPERIENCE_EDIT_SUCCESS =
  "LOGISTICS_EXPERIENCE_EDIT_SUCCESS";
export const LOGISTICS_EXPERIENCE_EDIT_ERROR =
  "LOGISTICS_EXPERIENCE_EDIT_ERROR";

export const LOGISTICS_EXPERIENCE_UPDATE_SUCCESS =
  "LOGISTICS_EXPERIENCE_UPDATE_SUCCESS";
export const LOGISTICS_EXPERIENCE_UPDATE_ERROR =
  "LOGISTICS_EXPERIENCE_UPDATE_ERROR";

//FMS

//  exp section

export const FMS_EXP_ADD_SUCCESS = "FMS_EXP_ADD_SUCCESS";
export const FMS_EXP_ADD_ERROR = "FMS_EXP_ADD_ERROR";

export const FMS_EXP_DELETE_SUCCESS = "FMS_EXP_DELETE_SUCCESS";
export const FMS_EXP_DELETE_ERROR = "FMS_EXP_DELETE_ERROR";

export const FMS_EXP_LIST_SUCCESS = "FMS_EXP_LIST_SUCCESS";
export const FMS_EXP_LIST_ERROR = "FMS_EXP_LIST_ERROR";

export const FMS_EXP_EDIT_SUCCESS = "FMS_EXP_EDIT_SUCCESS";
export const FMS_EXP_EDIT_ERROR = "FMS_EXP_EDIT_ERROR";

export const FMS_EXP_UPDATE_SUCCESS = "FMS_EXP_UPDATE_SUCCESS";
export const FMS_EXP_UPDATE_ERROR = "FMS_EXP_UPDATE_ERROR";

//  experience section

export const FMS_EXPERIENCE_ADD_SUCCESS = "FMS_EXPERIENCE_ADD_SUCCESS";
export const FMS_EXPERIENCE_ADD_ERROR = "FMS_EXPERIENCE_ADD_ERROR";

export const FMS_EXPERIENCE_DELETE_SUCCESS = "FMS_EXPERIENCE_DELETE_SUCCESS";
export const FMS_EXPERIENCE_DELETE_ERROR = "FMS_EXPERIENCE_DELETE_ERROR";

export const FMS_EXPERIENCE_LIST_SUCCESS = "FMS_EXPERIENCE_LIST_SUCCESS";
export const FMS_EXPERIENCE_LIST_ERROR = "FMS_EXPERIENCE_LIST_ERROR";

export const FMS_EXPERIENCE_EDIT_SUCCESS = "FMS_EXPERIENCE_EDIT_SUCCESS";
export const FMS_EXPERIENCE_EDIT_ERROR = "FMS_EXPERIENCE_EDIT_ERROR";

export const FMS_EXPERIENCE_UPDATE_SUCCESS = "FMS_EXPERIENCE_UPDATE_SUCCESS";
export const FMS_EXPERIENCE_UPDATE_ERROR = "FMS_EXPERIENCE_UPDATE_ERROR";

//capabilites section
export const FMS_CAPABILITIES_LIST_SUCCESS = "FMS_CAPABILITIES_LIST_SUCCESS";
export const FMS_CAPABILITIES_LIST_ERROR = "FMS_CAPABILITIES_LIST_ERROR";

export const FMS_CAPABILITIES_UPDATE_SUCCESS =
  "FMS_CAPABILITIES_UPDATE_SUCCESS";
export const FMS_CAPABILITIES_UPDATE_ERROR = "FMS_CAPABILITIES_UPDATE_ERROR";

//analysis section
export const FMS_ANALYSIS_LIST_SUCCESS = "FMS_ANALYSIS_LIST_SUCCESS";
export const FMS_ANALYSIS_LIST_ERROR = "FMS_ANALYSIS_LIST_ERROR";

export const FMS_ANALYSIS_UPDATE_SUCCESS = "FMS_ANALYSIS_UPDATE_SUCCESS";
export const FMS_ANALYSIS_UPDATE_ERROR = "FMS_ANALYSIS_UPDATE_ERROR";

//slider capabilites section
export const FMS_SLIDER_CAPABILITIES_LIST_SUCCESS =
  "FMS_SLIDER_CAPABILITIES_LIST_SUCCESS";
export const FMS_SLIDER_CAPABILITIES_LIST_ERROR =
  "FMS_SLIDER_CAPABILITIES_LIST_ERROR";

export const FMS_SLIDER_CAPABILITIES_UPDATE_SUCCESS =
  "FMS_SLIDER_CAPABILITIES_UPDATE_SUCCESS";
export const FMS_SLIDER_CAPABILITIES_UPDATE_ERROR =
  "FMS_SLIDER_CAPABILITIES_UPDATE_ERROR";

//space  section
export const FMS_SPACE_LIST_SUCCESS = "FMS_SPACE_LIST_SUCCESS";
export const FMS_SPACE_LIST_ERROR = "FMS_SPACE_LIST_ERROR";

export const FMS_SPACE_UPDATE_SUCCESS = "FMS_SPACE_UPDATE_SUCCESS";
export const FMS_SPACE_UPDATE_ERROR = "FMS_SPACE_UPDATE_ERROR";




//--------------------------------SEAPORTE------------------------------------------------------

//assurance section 

export const SEAPORTE_ASSURANCE_LIST_SUCCESS = "SEAPORTE_ASSURANCE_LIST_SUCCESS";
export const SEAPORTE_ASSURANCE_LIST_ERROR = "SEAPORTE_ASSURANCE_LIST_ERROR";

export const SEAPORTE_ASSURANCE_UPDATE_SUCCESS = "SEAPORTE_ASSURANCE_UPDATE_SUCCESS";
export const SEAPORTE_ASSURANCE_UPDATE_ERROR = "SEAPORTE_ASSURANCE_UPDATE_ERROR";

//objective section 

export const SEAPORTE_OBJECTIVE_LIST_SUCCESS = "SEAPORTE_OBJECTIVE_LIST_SUCCESS";
export const SEAPORTE_OBJECTIVE_LIST_ERROR = "SEAPORTE_OBJECTIVE_LIST_ERROR";

export const SEAPORTE_OBJECTIVE_UPDATE_SUCCESS = "SEAPORTE_OBJECTIVE_UPDATE_SUCCESS";
export const SEAPORTE_OBJECTIVE_UPDATE_ERROR = "SEAPORTE_OBJECTIVE_UPDATE_ERROR";


//--------------------------------SERVICES------------------------------------------------------


//capabilities 
export const SERVICES_CAPABILITIES_LIST_SUCCESS = "SERVICES_CAPABILITIES_LIST_SUCCESS";
export const SERVICES_CAPABILITIES_LIST_ERROR = "SERVICES_CAPABILITIES_LIST_ERROR";

export const SERVICES_CAPABILITIES_UPDATE_SUCCESS =
  "SERVICES_CAPABILITIES_UPDATE_SUCCESS";
export const SERVICES_CAPABILITIES_UPDATE_ERROR = "SERVICES_CAPABILITIES_UPDATE_ERROR";


//instructional 

export const SERVICES_INSTRUCTIONAL_LIST_SUCCESS = "SERVICES_INSTRUCTIONAL_LIST_SUCCESS";
export const SERVICES_INSTRUCTIONAL_LIST_ERROR = "SERVICES_INSTRUCTIONAL_LIST_ERROR";

export const SERVICES_INSTRUCTIONAL_UPDATE_SUCCESS =
  "SERVICES_INSTRUCTIONAL_UPDATE_SUCCESS";
export const SERVICES_INSTRUCTIONAL_UPDATE_ERROR = "SERVICES_INSTRUCTIONAL_UPDATE_ERROR";

//administative 

export const SERVICES_ADMINISTRATIVE_LIST_SUCCESS = "SERVICES_ADMINISTRATIVE_LIST_SUCCESS";
export const SERVICES_ADMINISTRATIVE_LIST_ERROR = "SERVICES_ADMINISTRATIVE_LIST_ERROR";

export const SERVICES_ADMINISTRATIVE_UPDATE_SUCCESS =
  "SERVICES_ADMINISTRATIVE_UPDATE_SUCCESS";
export const SERVICES_ADMINISTRATIVE_UPDATE_ERROR = "SERVICES_ADMINISTRATIVE_UPDATE_ERROR";


//  experience section

export const SERVICES_EXPERIENCE_ADD_SUCCESS = "SERVICES_EXPERIENCE_ADD_SUCCESS";
export const SERVICES_EXPERIENCE_ADD_ERROR = "SERVICES_EXPERIENCE_ADD_ERROR";

export const SERVICES_EXPERIENCE_DELETE_SUCCESS = "SERVICES_EXPERIENCE_DELETE_SUCCESS";
export const SERVICES_EXPERIENCE_DELETE_ERROR = "SERVICES_EXPERIENCE_DELETE_ERROR";

export const SERVICES_EXPERIENCE_LIST_SUCCESS = "SERVICES_EXPERIENCE_LIST_SUCCESS";
export const SERVICES_EXPERIENCE_LIST_ERROR = "SERVICES_EXPERIENCE_LIST_ERROR";

export const SERVICES_EXPERIENCE_EDIT_SUCCESS = "SERVICES_EXPERIENCE_EDIT_SUCCESS";
export const SERVICES_EXPERIENCE_EDIT_ERROR = "SERVICES_EXPERIENCE_EDIT_ERROR";

export const SERVICES_EXPERIENCE_UPDATE_SUCCESS = "SERVICES_EXPERIENCE_UPDATE_SUCCESS";
export const SERVICES_EXPERIENCE_UPDATE_ERROR = "SERVICES_EXPERIENCE_UPDATE_ERROR";


//technology section
export const SERVICES_TECHNOLOGY_LIST_SUCCESS = "SERVICES_TECHNOLOGY_LIST_SUCCESS";
export const SERVICES_TECHNOLOGY_LIST_ERROR = "SERVICES_TECHNOLOGY_LIST_ERROR";

export const SERVICES_TECHNOLOGY_UPDATE_SUCCESS = "SERVICES_TECHNOLOGY_UPDATE_SUCCESS";
export const SERVICES_TECHNOLOGY_UPDATE_ERROR = "SERVICES_TECHNOLOGY_UPDATE_ERROR";
